getFingerprintProtected